import type { SubjectFilterValues } from "./Components/Filters";

// Turns the filter bar values into query params for the subjects list endpoint,
// merged onto the per-tab base scope (country / exclude_country).
export const buildSubjectParams = (
  filters: SubjectFilterValues,
  base: Record<string, unknown>
): Record<string, unknown> => ({
  ...base,
  page_size: 9999,
  page: 1,
  ...(filters.status ? { status: filters.status } : {}),
  ...(filters.content_type ? { content_type: filters.content_type } : {}),
  ...(filters.topic.length ? { topic: filters.topic } : {}),
});

export const DEFAULT_SUBJECT_FILTERS: SubjectFilterValues = {
  status: "published",
  content_type: "",
  topic: [],
};
